export default "__VITE_ASSET__$m3TH1lE__"